module.exports = __webpack_public_path__ + "static/commercial-b0e850084a8472011397c622d6b945ad.jpg";